import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import IconTI from '@components/Images/Rebranding/IconTI';
import { partners_list_path } from '@routes';

const BrandPartner = () => {
  return (
    <aside className="mx-[calc(-50vw+50%)] my-80 min-h-[385px] bg-[url('https://tii.imgix.net/global/about/brand_partner.png')]	bg-cover bg-center bg-no-repeat">
      <div className="gap flex flex-col items-center justify-center py-48">
        <IconTI className="mb-48 w-28 text-primary-magenta" />
        <div className="flex max-w-lg flex-col items-center justify-center text-center">
          <div className="font-suisse-works text-headline-md">Brand Partnerships</div>
          <div className="mt-8 font-suisse-neue text-body-lg">
            The Information works with companies to reach our subscribers with high-quality
            messages.
          </div>
          <div className="flex">
            <PrimaryButton as="link" href={partners_list_path()} className="mt-32">
              Connect with our team
            </PrimaryButton>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default BrandPartner;
